import axios from "axios";
import { Auth } from "aws-amplify";
import { notification } from "antd";
import { client } from "../graphql/client";
import { childGql } from "../graphql/child";
import { OrgGql } from "../graphql/organization";
import { frFunGql } from "../graphql/fr/fundraiser";
import { teacherGql } from "../graphql/teacher";
import { engGql } from "../graphql/engagement";
import { meGql } from "../graphql/me";
import { feedbackGql } from "../graphql/feedback";
import { userGql } from "../graphql/user";
import { divisionGql } from "../graphql/division";
import { regionGql } from "../graphql/region";
import { familyGql } from "../graphql/family";
import { articleGql } from "../graphql/content/article";
import { communityGql } from "../graphql/community";
import { settingGql } from "../graphql/setting";
import { reportGql } from "../graphql/report";
import { dashboardGql } from "../graphql/dashboard";
import { invitationGql } from "../graphql/invitation";
import { employeeGql } from "../graphql/employee";
import { interestGql } from "../graphql/interest";
import { userActivitiesGql } from "../graphql/activities";
import { roleGql } from "../graphql/admin/role";
import { bannerGql } from "../graphql/banner";
import { postGql } from "../graphql/content/post";
import { volunteerGql } from "../graphql/volunteer";
import { utilsGql } from "../graphql/utils";

if (process.env.NODE_ENV === "production") {
  axios.defaults.baseURL = process.env.REACT_APP_ADMIN_API;
}
axios.defaults.baseURL = process.env.REACT_APP_ADMIN_API;

axios.interceptors.request.use(
  async (config) => {
    if (process.env.NODE_ENV === "production") {
      config.headers = {
        Authorization: (await Auth.currentSession()).getIdToken().getJwtToken(),
      };
    } else {
      config.headers = {
        // "x-fm-uid": await Aws.getUserId()
      };
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response && error.response.data)
      notification.error({
        message: error.response.data.message || "Service Error.",
      });
    return Promise.reject(error);
  }
);

export const Api = {
  hi: () => axios.get("/id1"),
  timezone: () => axios.get("/manage/setting/timezone"),

  me: {
    me: () => client.query({ query: meGql.me, fetchPolicy: "network-only" }),
    unreadMsg: () => client.query({ query: meGql.unreadMsg, fetchPolicy: "network-only" }),
    regionsTree: () => client.query({ query: regionGql.regionsTree, fetchPolicy: "network-only" }),
  },
  dashboard: {
    stats: () => axios.get("/manage/stats"),
    analysisAppUser: (filter) =>
      client.query({ query: dashboardGql.analysisAppUser, variables: { filter }, fetchPolicy: "network-only" }),
    analysisAppUserPeer: (filter) =>
      client.query({ query: dashboardGql.analysisAppUserPeer, variables: { filter }, fetchPolicy: "network-only" }),
    analysisAppRating: (filter) =>
      client.query({ query: dashboardGql.analysisAppRating, variables: { filter }, fetchPolicy: "network-only" }),
    analysisUserRating: (filter) =>
      client.query({ query: dashboardGql.analysisUserRating, variables: { filter }, fetchPolicy: "network-only" }),
    analysisPostUsageTrends: (filter) =>
      client.query({ query: dashboardGql.analysisPostUsageTrends, variables: { filter }, fetchPolicy: "network-only" }),
    analysisPsUsageTrends: (filter) =>
      client.query({ query: dashboardGql.analysisPsUsageTrends, variables: { filter }, fetchPolicy: "network-only" }),
  },
  admin: {
    list: () => axios.get("/manage/employee"),
    save: (data) => axios.put("/manage/employee", data),
    enabled: (data) => axios.post("/manage/employee/enabled", data),
    disabled: (data) => axios.post("/manage/employee/disabled", data),
    resetPwd: (data) => axios.post("/manage/employee/pwd/reset", data),
    // employee: data => axios.put('/manage/employee', data)

    role: {
      roles: () => client.query({ query: roleGql.authRoles, fetchPolicy: "network-only" }),
      save: (input) => client.mutate({ mutation: roleGql.saveAuthRole, variables: { input } }),
      del: (id) => client.mutate({ mutation: roleGql.delAuthRole, variables: { id } }),
    },
  },
  employee: {
    list: () => client.query({ query: employeeGql.employees, fetchPolicy: "network-only" }),
    get: (id) => client.query({ query: employeeGql.employee, variables: { id }, fetchPolicy: "network-only" }),
    save: (input) => client.mutate({ mutation: employeeGql.saveEmployee, variables: { input } }),
    resend: (id) => client.mutate({ mutation: employeeGql.ResendEmployee, variables: { id } }),
    setEnabled: (id, enabled) => client.mutate({ mutation: employeeGql.SetEmployeeEnable, variables: { id, enabled } }),
  },
  region: {
    list: () => client.query({ query: regionGql.regions, fetchPolicy: "network-only" }),
    regions: () => client.query({ query: regionGql.regions2, fetchPolicy: "network-only" }),
    check: (input) => client.query({ query: regionGql.checkRegion, variables: { input }, fetchPolicy: "network-only" }),
    save: (input) => client.mutate({ mutation: regionGql.saveRegion, variables: { input } }),
  },
  division: {
    list: () => client.query({ query: divisionGql.findDivision, fetchPolicy: "network-only" }),
    save: (input) => client.mutate({ mutation: divisionGql.saveDivision, variables: { input } }),
  },
  community: {
    saveCommunity: (input) => client.mutate({ mutation: communityGql.saveCommunity, variables: { input } }),
    communities: (filter) =>
      client.query({ query: communityGql.communities, variables: { filter }, fetchPolicy: "network-only" }),
    community: (id) => client.query({ query: communityGql.community, variables: { id }, fetchPolicy: "network-only" }),
    childcareFare: () =>
      client.query({ query: communityGql.childcareFare, variables: {}, fetchPolicy: "network-only" }),
  },
  org: {
    orgDict: (filter) => client.query({ query: OrgGql.orgDict, fetchPolicy: "network-only", variables: { filter } }),

    save: (input) => client.mutate({ mutation: OrgGql.saveOrg, variables: { input } }),
    confirm: (input) => client.mutate({ mutation: OrgGql.confirmOrg, variables: { input } }),
    getEditOrg: (id) => client.query({ query: OrgGql.getEditOrg, variables: { id }, fetchPolicy: "network-only" }),
    org: (id) => client.query({ query: OrgGql.org, variables: { id }, fetchPolicy: "network-only" }),
    orgs: (filter) => client.query({ query: OrgGql.orgs, variables: { filter }, fetchPolicy: "network-only" }),
    teachers: (id) =>
      client.query({ query: teacherGql.teachers, variables: { filter: { orgId: id } }, fetchPolicy: "network-only" }),
    members: (id) => client.query({ query: OrgGql.orgMembers, variables: { id }, fetchPolicy: "network-only" }),
  },
  fr: {
    saveFundraising: (input) => client.mutate({ mutation: frFunGql.saveFundraising, variables: { input } }),
    saveFundPerGoalResult: (id, items) =>
      client.mutate({ mutation: frFunGql.saveFundPerGoalResult, variables: { id, items } }),
    completeFundPerGoalByEmployee: (id) =>
      client.mutate({ mutation: frFunGql.completeFundPerGoalByEmployee, variables: { id } }),
    acceptFundraising: (id) => client.mutate({ mutation: frFunGql.acceptFundraising, variables: { id } }),
    rejectFundraising: (id) => client.mutate({ mutation: frFunGql.rejectFundraising, variables: { id } }),
    fundraisings: (filter) =>
      client.query({ query: frFunGql.FrFundraisers, variables: { filter }, fetchPolicy: "network-only" }),
    fundraising: (id) => client.query({ query: frFunGql.FrFundraiser, variables: { id }, fetchPolicy: "network-only" }),
    exportDonates: (id) =>
      client.query({ query: frFunGql.exportDonates, variables: { id }, fetchPolicy: "network-only" }),
  },

  user: {
    users: (filter) => client.query({ query: userGql.users, variables: { filter }, fetchPolicy: "network-only" }),
    user: (id) => client.query({ query: userGql.user, variables: { id }, fetchPolicy: "network-only" }),
    save: (input) => client.mutate({ mutation: userGql.saveUser, variables: { input } }),
    setUserChooseCommunity: (input) => client.mutate({ mutation: userGql.setUserChooseCommunity, variables: input }),
    findByEmail: (email) =>
      client.query({ query: userGql.findUserByEmail, variables: { email }, fetchPolicy: "network-only" }),
    findByEmailWithChildren: (email) =>
      client.query({ query: userGql.findUserByEmailWithChildren, variables: { email }, fetchPolicy: "network-only" }),
    childUpdates: (filter) =>
      client.query({ query: childGql.childUpdates, fetchPolicy: "network-only", variables: { filter } }),
    confirmUpdate: (input) => client.mutate({ mutation: childGql.confirmUpdate, variables: { input } }),

    setShareEduOffer: (input) => client.mutate({ mutation: userGql.setShareEduOffer, variables: { ...input } }),
    updateUserIsShareEduOffer: (input) =>
      client.mutate({ mutation: userGql.updateUserIsShareEduOffer, variables: { ...input } }),
  },
  userActivities: {
    eduShareStats: (id) =>
      client.query({ query: userActivitiesGql.eduShareStats, variables: { id }, fetchPolicy: "network-only" }),
    userActivities: (filter) =>
      client.query({ query: userActivitiesGql.userActivities, variables: { filter }, fetchPolicy: "network-only" }),
    userActivity: (id) =>
      client.query({ query: userActivitiesGql.userActivity, variables: { id }, fetchPolicy: "network-only" }),
    psDetails: (category, id) => {
      let query;
      if (category === "Carpool Request") {
        query = userActivitiesGql.carpoolRequest;
      } else if (category === "Childcare Request") {
        query = userActivitiesGql.childcareRequest;
      } else if (category === "uShare Request") {
        query = userActivitiesGql.uShareRequest;
      } else if (category === "Carpool Offer") {
        query = userActivitiesGql.carpoolOffer;
      } else if (category === "uShare Offer") {
        query = userActivitiesGql.uShareOffer;
      } else if (category === "eduShare Offer") {
        query = userActivitiesGql.eduShareOffer;
      } else {
        query = userActivitiesGql.userActivity;
      }
      return client.query({ query, variables: { id }, fetchPolicy: "network-only" });
    },
  },
  family: {
    get: (userId, childId) =>
      client.query({ query: familyGql.family, variables: { userId, childId }, fetchPolicy: "network-only" }),
    familyAddExistingParent: (childIds, userId) =>
      client.mutate({ mutation: familyGql.familyAddExistingParent, variables: { childIds, userId } }),
    familyAddNewParent: (input) => client.mutate({ mutation: familyGql.familyAddNewParent, variables: { input } }),

    familyAddExistingChild: (childId, parentIds) =>
      client.mutate({ mutation: familyGql.familyAddExistingChild, variables: { childId, parentIds } }),
    familyAddNewChild: (input) => client.mutate({ mutation: familyGql.familyAddNewChild, variables: { input } }),

    updateChild: (input) => client.mutate({ mutation: familyGql.updateChild, variables: { input } }),
    updateUserRoles: (userId, roles) =>
      client.mutate({ mutation: familyGql.updateUserRoles, variables: { userId, roles } }),
    updateUserNote: (userId, note) =>
      client.mutate({ mutation: familyGql.updateUserNote, variables: { userId, note } }),
    updateUserSexOffender: (userId, state) =>
      client.mutate({ mutation: familyGql.updateUserSexOffender, variables: { userId, state } }),
    enableUserAccount: (userId, reason) =>
      client.mutate({ mutation: familyGql.enableUserAccount, variables: { userId, reason } }),
    disableUserAccount: (userId, reason) =>
      client.mutate({ mutation: familyGql.disableUserAccount, variables: { userId, reason } }),

    changeChildrenSchool: (input) => client.mutate({ mutation: familyGql.changeChildrenSchool, variables: { input } }),
  },
  child: {
    get: (id) => client.query({ query: childGql.child, variables: { id }, fetchPolicy: "network-only" }),
    children: (filter) =>
      client.query({ query: childGql.children, variables: { filter }, fetchPolicy: "network-only" }),
  },
  interest: {
    list: () => client.query({ query: interestGql.interests, fetchPolicy: "network-only" }),
    check: (input) =>
      client.query({ query: interestGql.checkInterest, variables: { input }, fetchPolicy: "network-only" }),
    add: (input) => client.mutate({ mutation: interestGql.addInterest, variables: { input } }),
  },
  invitation: {
    channelInvitations: (filter) =>
      client.query({ query: invitationGql.channelInvitations, variables: { filter }, fetchPolicy: "network-only" }),
    saveChannelInvitation: (input) =>
      client.mutate({ mutation: invitationGql.saveChannelInvitation, variables: { input } }),
  },
  feedback: {
    feedbacks: (filter) =>
      client.query({ query: feedbackGql.feedbacks, variables: { filter }, fetchPolicy: "network-only" }),
  },
  idcheck: {
    list: (filter) =>
      client.query({ query: userGql.userVerifications, variables: { filter }, fetchPolicy: "network-only" }),
    get: (id) => client.query({ query: userGql.userVerification, variables: { id }, fetchPolicy: "network-only" }),
    confirm: (input) => client.mutate({ mutation: userGql.confirmIdVerification, variables: { input } }),
  },
  engTool: {
    WorkSubmissions: () => client.query({ query: engGql.engToolWorkSubmissions, fetchPolicy: "network-only" }),
    activities: () => client.query({ query: engGql.engToolActivities, fetchPolicy: "network-only" }),
    engActivities: (filter) =>
      client.query({ query: engGql.engActivities, variables: { filter }, fetchPolicy: "network-only" }),
  },
  content: {
    article: {
      articles: (filter) =>
        client.query({ query: articleGql.articles, variables: { filter }, fetchPolicy: "network-only" }),
      article: (id) => client.query({ query: articleGql.article, variables: { id }, fetchPolicy: "network-only" }),
      articlePublishRegions: (articleId) =>
        client.query({
          query: articleGql.articlePublishRegions,
          variables: { articleId },
          fetchPolicy: "network-only",
        }),

      save: (input) => client.mutate({ mutation: articleGql.saveArticle, variables: { input } }),
      publish: (input) => client.mutate({ mutation: articleGql.saveArticlePublish, variables: { input } }),
      withdrawn: (id) => client.mutate({ mutation: articleGql.withdrawnArticlePublish, variables: { id } }),

      publishes: (filter) =>
        client.query({ query: articleGql.articlePublishes, variables: { filter }, fetchPolicy: "network-only" }),
      comments: (filter) =>
        client.query({ query: articleGql.articleComments, variables: { filter }, fetchPolicy: "network-only" }),
    },
    post: {
      posts: (filter) => client.query({ query: postGql.posts, variables: { filter }, fetchPolicy: "network-only" }),
      post: (id) => client.query({ query: postGql.post, variables: { id }, fetchPolicy: "network-only" }),
      del: (id) => client.mutate({ mutation: postGql.delPost, variables: { id } }),
      comments: (filter) =>
        client.query({ query: postGql.postComments, variables: { filter }, fetchPolicy: "network-only" }),
      delComment: (id) => client.mutate({ mutation: postGql.delPostComment, variables: { id } }),
    },
  },
  setting: {
    appVersion: () => client.query({ query: settingGql.appVersion }),
    checkVersion: (input) =>
      client.query({ query: settingGql.checkAppVersion, variables: { input }, fetchPolicy: "network-only" }),
    appVersions: () => client.query({ query: settingGql.appVersions, fetchPolicy: "network-only" }),
    addAppVersion: (input) => client.mutate({ mutation: settingGql.addAppVersion, variables: { input } }),
    delAppVersion: (id) => client.mutate({ mutation: settingGql.delAppVersion, variables: { id } }),

    systemSettings: () => client.query({ query: settingGql.systemSettings, fetchPolicy: "network-only" }),
    saveSystemSettings: (input) => client.mutate({ mutation: settingGql.saveSystemSettings, variables: { input } }),
  },
  report: {
    reports: (filter) => client.query({ query: reportGql.reports, variables: { filter }, fetchPolicy: "network-only" }),
    acceptReport: (id, note = "") => client.mutate({ mutation: reportGql.acceptReport, variables: { id, note } }),
    rejectReport: (id, note = "") => client.mutate({ mutation: reportGql.rejectReport, variables: { id, note } }),
  },
  banner: {
    banners: (filter) => client.query({ query: bannerGql.banners, variables: { filter }, fetchPolicy: "network-only" }),
    banner: (id) => client.mutate({ mutation: bannerGql.banner, variables: { id } }),
    saveBanner: (input) => client.mutate({ mutation: bannerGql.saveBanner, variables: { input } }),
    delBanner: (id) => client.mutate({ mutation: bannerGql.delBanner, variables: { id } }),
  },
  volunteer: {
    volunteers: (filter) =>
      client.query({ query: volunteerGql.volunteers, variables: { filter }, fetchPolicy: "network-only" }),
    volunteer: (id) => client.query({ query: volunteerGql.volunteer, variables: { id }, fetchPolicy: "network-only" }),
    exportVolunteer: (id) =>
      client.query({ query: volunteerGql.exportVolunteer, variables: { id }, fetchPolicy: "network-only" }),
    createVolunteer: (input) => client.mutate({ mutation: volunteerGql.createVolunteer, variables: { input } }),
    cancelVolunteer: (activityId, date) =>
      client.mutate({ mutation: volunteerGql.cancelVolunteer, variables: { activityId, date } }),
    sendHostEmail: (id) => client.mutate({ mutation: volunteerGql.volunteerEmail2Host, variables: { id } }),
    applications: (id) =>
      client.query({ query: volunteerGql.volunteerApplications, variables: { id }, fetchPolicy: "network-only" }),
    history: (filter) =>
      client.query({ query: volunteerGql.volunteerHistory, variables: { filter }, fetchPolicy: "network-only" }),
    confirmApplication: (applicationId, confirmed) =>
      client.mutate({ mutation: volunteerGql.confirmVolunteerApplication, variables: { applicationId, confirmed } }),
    setVolunteerStatus: (activityId, pause) =>
      client.mutate({ mutation: volunteerGql.setVolunteerStatus, variables: { activityId, pause } }),
  },
  utils: {
    searchGooglePlaces: (keyword) =>
      client.query({ query: utilsGql.searchGooglePlaces, variables: { keyword }, fetchPolicy: "network-only" }),
  },
};
